import { parseTenThousandths } from '@/shared/utils/moneyArithmetic';
import type { SoldAddOn, SoldItem } from '../types/agreements.types';

/** Wire's 4dp scale, as an integer, so sums never accumulate float error (P-D7). */
export const SCALE = 10_000;

export const toScaled = (value: number): number => {
    const scaled = parseTenThousandths(value.toFixed(4));
    if (scaled === null) {
        throw new Error('Money value is not a finite amount');
    }
    return Number(scaled);
};

export const fromScaled = (value: number): number => value / SCALE;

export interface ScaledLine {
    net: number;
    gross: number;
}

/** What invoicing charges for the item: the server's allocated line, else unit x quantity exactly. */
export const itemLineScaled = (item: SoldItem): ScaledLine => ({
    net: item.lineNet === undefined ? toScaled(item.unitNet) * item.quantity : toScaled(item.lineNet),
    gross: item.lineGross === undefined ? toScaled(item.unitGross) * item.quantity : toScaled(item.lineGross),
});

export const addOnLineScaled = (addOn: SoldAddOn): ScaledLine => ({
    net: toScaled(addOn.unitNet) * addOn.quantity,
    gross: toScaled(addOn.unitGross) * addOn.quantity,
});
